var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiCheckboxInput',{ref:"multiCheckbox",attrs:{"id":_vm.id,"content":_vm.content,"payload":_vm.payload,"expand-button-text":_vm.expandButtonText},on:{"change_multicheckbox":_vm.change_multicheckbox}})
}
var staticRenderFns = []

export { render, staticRenderFns }